import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';

import { useAppDispatch } from 'store/store';
import { cancelSubscription } from 'store/user-service/asyncActions';

import { NamespacesList } from 'core/enums/common';

import { CancelButton, ConfirmButton } from 'components/Profile/DeleteAccountModal/styled';
import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

interface CancelRenewalModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const CancelRenewalModal: FC<CancelRenewalModalProps> = ({ isOpen, onClose }) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);
	const [cancelingRenewalLoading, setCancelingRenewalLoading] = useState(false);

	const dispatch = useAppDispatch();

	const handleConfirm = async () => {
		setCancelingRenewalLoading(true);
		await dispatch(cancelSubscription());
		setCancelingRenewalLoading(false);
		onClose();
	};

	return (
		<InfoModal
			isOpen={isOpen}
			image={<Error />}
			onClose={onClose}
			title={modalTranslate('cancelRenewalModal.title')}
			description={modalTranslate('cancelRenewalModal.description')}
			buttons={
				<>
					{cancelingRenewalLoading ? (
						<ConfirmButton variant="outlined" color="error" disabled={cancelingRenewalLoading}>
							<Oval
								height={24}
								width={24}
								color="#fff"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
								ariaLabel="oval-loading"
								secondaryColor="#91B6FF"
								strokeWidth={5}
								strokeWidthSecondary={5}
							/>
						</ConfirmButton>
					) : (
						<ConfirmButton variant="outlined" color="error" onClick={handleConfirm}>
							{modalTranslate('cancelRenewalModal.confirm')}
						</ConfirmButton>
					)}

					<CancelButton variant="contained" color="error" onClick={onClose}>
						{modalTranslate('cancelRenewalModal.cancel')}
					</CancelButton>
				</>
			}
		></InfoModal>
	);
};
